<template>
  <div class="ride-new-private-transport-customer">
    <div class="notification is-white">
      <button class="delete is-medium" @click="close"></button>
      <div class="subtitle has-text-link">{{ w.business.name }}</div>

      <p style="margin-bottom: 10px">
        <i>{{ $t("ride.must-be-a-resident-to-use") }}</i>
      </p>

      <div v-if="requiresUnitNumber">
        <p style="margin-bottom: 10px">
          {{ $t("passenger.enter-unit-number") }}
          <span class="has-text-info">(required)</span>
        </p>
        <div class="field">
          <p class="control has-icons-left">
            <input
              class="input is-medium"
              v-model="unitNumber"
              type="text"
              :placeholder="$t('ride.unit-number')"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-door-closed"></i>
            </span>
          </p>
        </div>
      </div>

      <div v-if="requiresPasscode">
        <p style="margin-bottom: 10px">
          Enter Passcode
          <span class="has-text-info">(required)</span>
        </p>
        <div class="field">
          <p class="control has-icons-left">
            <input
              class="input is-medium"
              v-model="passcode"
              type="text"
              placeholder="4-digit Passcode"
              onfocus="value = ''"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-lock"></i>
            </span>
          </p>
        </div>
        <p v-show="invalidPasscode" class="has-text-danger">Invalid passcode</p>
      </div>

      <div style="margin-top: 20px; margin-bottom: 20px">
        <span
          class="button is-medium is-primary is-rounded is-fullwidth"
          :disabled="invalidForm"
          @click="submit"
        >
          {{ $t("submit") }}&nbsp;<i class="fa fa-chevron-right fa-lg" />
        </span>
      </div>

      <div class="has-text-right">
        <a class="button is-rounded" href="https://m.me/tukapp" target="_blank">
          {{ $t("ride.trouble-contact-us") }}&nbsp;
          <i class="fa fa-comment fa-lg has-text-link" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    workflow: Object,
  },
  data() {
    return {
      unitNumber: null,
      passcode: null,
      invalidPasscode: false,
    };
  },
  computed: {
    w() {
      return this.workflow;
    },
    invalidForm() {
      if (!this.requiresUnitNumber) return false;
      if (this.unitNumber) return false;
      return true;
    },
    requiresUnitNumber() {
      return this.w.data.requires_unit_number;
    },
    requiresPasscode() {
      return this.w.data.requires_authentication;
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      if (!this.requiresUnitNumber && !this.requiresPasscode) {
        this.$emit("success", this.w);
        this.close();
        return;
      }
      if (this.invalidForm) {
        this.errorToast(this.$t("passenger.unit-number-required"));
        return;
      }
      // first check passcode if one was required
      if (this.requiresPasscode) {
        this.invalidPasscode = false; // reset first
        if (this.passcode.length < 4 || this.passcode.length > 4) {
          this.invalidPasscode = true; // "Passcode is 4 digits long";
          return;
        }
        if (this.passcode !== this.w.data.passcode) {
          this.invalidPasscode = true; // "Incorrect passcode!";
          return;
        }
      }
      this.createCustomerRole();
    },
    createCustomerRole() {
      var data = null;
      if (this.requiresUnitNumber) {
        data = { unit_number: this.unitNumber };
      }
      this.$store
        .dispatch("createRole", {
          phone_number: this.$store.getters.phoneNumber,
          business_id: this.w.business_id,
          workflow_id: this.w.id,
          workflow_name: this.w.name,
          role_type: "customer",
          role_name: "Passenger",
          data: data,
        })
        .then(() => {
          this.success();
          this.updateRoles(false);
          this.$emit("success", this.w);
          this.close();
        })
        .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 12px;
}
p {
  margin-bottom: 10px;
}
</style>